import { useTranslation } from 'react-i18next';
import FieldWrapper from '../../../../components/formInputs/FieldWrapper';
import { deleteIcon } from '../../../../config/variables';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandAccordion from '../../../products/components/productForm/ExpandAccordion';
import DatePickerField from '../../../../components/formInputs/DatePickerField';
import { useMediaQuery } from 'react-responsive';

export default function LocationWorkingHoursItem({
  data,
  add,
  expanded,
  setExpanded,
  index,
  arrayHelpers
}: {
  data?: any;
  interior?: boolean;
  add?: boolean;
  expanded: number;
  setExpanded: React.Dispatch<React.SetStateAction<number>>;
  index: number;
  arrayHelpers?: any;
}) {
  const { t,i18n } = useTranslation();
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });

  return (
    <Accordion
      expanded={expanded === index}
      onChange={(e) => {
        e.stopPropagation();
        setExpanded(expanded === index ? -1 : index);
      }}
    >
      <AccordionSummary
        sx={{
          '&.Mui-focusVisible': {
            backgroundColor: '#000'
          }
        }}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className={`header-container ${expanded !== index && 'expand'}`}
      >
        <div className="header-content">
          <p>
            <ExpandAccordion expand={expanded === index} /> {data?.day?.[`${i18n.language || "en"}`] || `Item ${index + 1}`}
          </p>
          {!add && <span
            onClick={(e) => {
              e.stopPropagation();
              arrayHelpers?.remove(index);
            }}
          >
            {deleteIcon}
          </span>}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className="inputs_group">
          <FieldWrapper title={t(`day_en`)} inputName={`working_hours[${index}].day[en]`} inputPlaceholder={t('day_en')} input customPadding />
          <FieldWrapper title={t('day_en')} inputName={`working_hours[${index}].day[ar]`} inputPlaceholder={t('day_ar')} input customPadding />
        </div>
        <div className="inputs_group">
          <DatePickerField title={t(`from`)} name={`working_hours[${index}].from`} noPadding={!isMobile} placeHolder='HH:mm' isTimePicker/>
          <DatePickerField title={t(`to`)} name={`working_hours[${index}].to`} noPadding  placeHolder='HH:mm' isTimePicker/>
        </div>
      </AccordionDetails>
    </Accordion>
  );
}
